<div class="files-root">
  <div class="head">

    <form action="" class="search">
      <input type="search" (keyup)="searchEvent($event)" />
      <i class="fas fa-search"><img class="search-icon" src="/assets/images/search-logo.svg" /></i>
    </form>
  </div>

  <div class="list">
    <ul *ngFor="let item of filteredFiles | keyvalue">
      <span class="title">{{ item.key }}</span>
      <ul>
        <li *ngFor="let doc of item.value" class="li-no-bullet files">
          <span class="name">{{ doc._related.files[0].original_filename }}</span>
          <span (click)="download(doc)" class="image"><img src="/assets/images/download.svg" /></span>
        </li>
      </ul>
    </ul>
  </div>

  <div *ngIf="isEmpty() === true" class="empty">
    <p>Aucun documents trouvés</p>
  </div>
</div>
